export default "__VITE_ASSET__8RsJIETd__"